export const color = {
  black: "#000000",
  offBlack: "#373737",
  blue: "#1BA2CC",
  almostBlue: "#2EC0EE",
  link: "#1BA2CC",
  midGray: "#A9A9A9",
  lightGray: "#D8D8D8",
  lightYellow: "#FFFF84",
  darkGray: "#3E3E3E",
  whiteGray: "#EFEFEF",
  white: "#FFF",
  gold: "#FFCE54",
  dimmedOpaqueWhite: "rgba(255, 255, 255, 0.6)",
  offWhite: "#FAFAFA",
  discreteText: "#626262",
  red: "#C24040",
  pink: "#F8EAEA",
  green: "#61B05E",
  whiteGreen: "#E3F3E3",
  orange: "#C17E2E",
  purple: "#B762CC",
  iconGradient: "linear-gradient(180deg, #1BA2CC 0%, #6BC069 100%)",
  linkOpaqueBg: "rgba(27, 162, 204, 0.05)",
  linkHover: "rgba(27, 162, 204, 0.1)",
  greenLightOpaque: "rgba(107, 192, 105, 0.1)",
  redLightOpaque: "rgba(186, 46, 46, 0.1)",
  blackLightOpaque: "rgba(0, 0, 0, 0.03)",
  searchBorder: "#E2E2E2",
  formBorder: "#EBEBEB",
};
